/**
 * Copyright (C) 2025 Spanning Cloud Apps.  All rights reserved.
 */
import './supportdropdown.tpl.html';

/**
 * Module for the Support Dropdown Menu
 */
angular
  .module('shared.supportdropdown', [])
  .controller('supportdropdownCtrl', function ($scope, configService, $uibModal, bodyUtils) {
    $scope.data = $scope.data || {};

    /**
     * Function to launch the support modal.
     */
    const openSupportModal = function () {
      // make sure the body is large enough to hold the support dialog
      bodyUtils.setBodyStyle({ height: '565px' });
      $uibModal
        .open({
          templateUrl: 'shared/modal/supportModal.tpl.html',
          controller: 'HelpModalCtrl',
          windowClass: 'sbsf-support-modal-window',
          scope: $scope
        })
        .result.then(
          function () {
            // case where modal is resolved
            bodyUtils.setBodyStyle(undefined);
          },
          function () {
            // case where modal is rejected
            bodyUtils.setBodyStyle(undefined);
          }
        );
    };

    configService.getConfig().then((config) => {
      $scope.ideasPortalLink = config && config.documentationLinks && config.documentationLinks.ideasPortal;

      $scope.kaseyaOnePortal = config && config.supportLink;

      const dropdownItems = [];

      if ($scope.ideasPortalLink) {
        dropdownItems.push({
          type: 'MENU_ITEM',
          text: 'HELP_MENU_IDEAS_PORTAL',
          handler: () => window.open($scope.ideasPortalLink, '_blank')
        });
      }

      if ($scope.kaseyaOnePortal) {
        dropdownItems.push({
          type: 'MENU_ITEM',
          text: 'SUPPORT_PORTAL',
          handler: () => window.open($scope.kaseyaOnePortal, '_blank')
        });
      }

      dropdownItems.push({
        type: 'MENU_ITEM',
        text: 'ABOUT',
        handler: () => openSupportModal()
      });

      $scope.data.dropdown = dropdownItems;
    });

    $scope.userDropdownIconCls = {
      'sca-icon-header-help': true,
      'header-kaseya-icon': true
    };
  })
  /**
   * The directive for the supportdropdown.
   */
  .directive('supportdropdown', function () {
    return {
      templateUrl: 'shared/supportdropdown/supportdropdown.tpl.html',
      scope: {
        onShowHide: '&showhide'
      },
      controller: 'supportdropdownCtrl'
    };
  });
